import Dialog from "@stimulus-components/dialog"

export default class extends Dialog {
  static values = {
    url: String,
    title: String
  }

  static targets = ["copyButton", "copyIcon", "checkIcon"]

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.showCopySuccess()
    } catch (err) {
      console.error("Failed to copy:", err)
    }
  }

  showCopySuccess() {
    this.copyIconTarget.classList.add("hidden")
    this.checkIconTarget.classList.remove("hidden")
    this.copyButtonTarget.classList.add("bg-green-100", "text-green-700")
    this.copyButtonTarget.classList.remove("bg-gray-100", "text-gray-700")

    setTimeout(() => {
      this.copyIconTarget.classList.remove("hidden")
      this.checkIconTarget.classList.add("hidden")
      this.copyButtonTarget.classList.remove("bg-green-100", "text-green-700")
      this.copyButtonTarget.classList.add("bg-gray-100", "text-gray-700")
    }, 2000)
  }
}
